import { useState, useContext } from "react";
import { MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlinePostAdd, MdOutlineNoteAlt } from "react-icons/md";
//Import from project
import "../../../Style/actionstyle.scss";
import { IoMdEye } from "react-icons/io";
import { AuthContext } from "../../../Context/AuthContext";
import { hasPermission } from "../../../Context/Permission";
import NoteStudentComplete from "./NoteStudentComplete";
import UpdateEnrollmentHourRecord from "./UpdateEnrollmentHourRecord";
import ContinueEnrollmentHourRecord from "./ContinueEnrollmentHourRecord";
import useNoteStudentCompleteClass from "../../../Hooks/useNoteStudentCompleteClass";

export default function StudentAction({ editData, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openNote, setOpenNote] = useState(false);
  const handleOpenNote = () => setOpenNote(true);
  const handleCloseNote = () => setOpenNote(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openContinue, setOpenContinue] = useState(false);
  const handleOpenContinue = () => setOpenContinue(true);
  const handleCloseContinue = () => setOpenContinue(false);

  let navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  let classId = params.get("classId");

  // console.log("editData::", editData)

  const { tableData: noteData } = useNoteStudentCompleteClass({
    enrollmentId: editData?.enrollmentId?._id,
  });

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {/* ======== Continue Study ========= */}
        <Tooltip title={t("note")} placement="top">
          <IconButton onClick={handleOpenNote}>
            <Box className="update-container">
              <MdOutlineNoteAlt className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        {/* ======== Continue Study ========= */}
        <Tooltip title={t("continue_study")} placement="top">
          <IconButton onClick={handleOpenContinue}>
            <Box className="add-container">
              <MdOutlinePostAdd className="add-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        {/* ========= update completed ========== */}
        {/* <Tooltip title={t("thead_graduate")} placement="top">
          <IconButton 
          // onClick={handleOpenEdit}
          >
            <Box className="delete-container">
              <TiTickOutline className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip> */}

        {hasPermission(userLogin?.user?.role, "view:student") && (
          <Tooltip title={t("view")} placement="top">
            <IconButton
              onClick={() =>
                navigate(
                  `/class/class-detail/student-detail?studentId=${editData?._id}&classId=${classId}`,
                )
              }
            >
              <Box className="view-container">
                <IoMdEye className="view-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}

        {/* ==== update hour ====== */}
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openNote && (
        <NoteStudentComplete
          open={openNote}
          handleClose={handleCloseNote}
          classId={classId}
          editData={editData}
          setRefetch={setRefetch}
          noteData={noteData}
        />
      )}

      {openContinue && (
        <ContinueEnrollmentHourRecord
          open={openContinue}
          classId={classId}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseContinue}
        />
      )}

      {openEdit && (
        <UpdateEnrollmentHourRecord
          open={openEdit}
          editData={editData}
          classId={classId}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}
    </div>
  );
}
